import { IconClose } from "@humansignal/icons";
import { useTranslation } from "@humansignal/core";
import { Button } from "../button/button";
import { useModalControls } from "./ModalPopup";

export const ModalCloseButton = () => {
  const { t } = useTranslation();
  const modal = useModalControls();
  return (
    <Button
      look="string"
      className="!p-0 [&_svg]:!w-6 [&_svg]:!h-6"
      leading={<IconClose />}
      aria-label={t("libs.ui.lib.modal.modalclosebutton.close_modal")}
      onClick={() => modal?.hide()}
    />
  );
};
